import React from 'react';

interface Props {
  labelOne: string;
  labelTwo: string;
}

interface State {
  showAllText: any;
  scrollPosition: number;
}

class Collapse extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      showAllText: false,
      scrollPosition: 0,
    };
  }
  handleOnClick = () => {
    const lastScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    this.setState({ showAllText: !this.state.showAllText, scrollPosition: lastScrollY });
    if (this.state.showAllText) {
      window.scrollTo(0, this.state.scrollPosition);
    }
  };

  render() {
    const { showAllText } = this.state;
    const { labelOne, labelTwo } = this.props;
    return (
      <div className={`collapse-container`}>
        <div className={`trans-btn btn-sm read-more ${showAllText ? 'hide' : 'show'}`} onClick={this.handleOnClick}>
          {labelOne}
        </div>
        <div className={`collapse-inner ${showAllText ? 'show' : ''}`}>
          {this.props.children}
          <div className={`trans-btn btn-sm read-less`} onClick={this.handleOnClick}>
            {labelTwo}
          </div>
        </div>
      </div>
    );
  }
}
export default Collapse;
